import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { NotificationHeaderWrapper } from 'src/components/Header/LHSMenu/NotificationsMenu/NotificationsMenu';
import {
    NotificationListContainer,
    NotificationsMenuBetsItemContainer,
} from 'src/components/Header/LHSMenu/NotificationsMenu/NotificationsMenuLists/NotificationsMenuLists.style';
import { useCommon } from 'src/AppState/Common';
import { NotificationsCentreState } from 'src/components/NotificationsCentre/NotificationsCentreState';
import { NotificationsMenuBetsItem } from './NotificationsBetsItem';
import { action, makeAutoObservable, observable } from 'mobx';
import { NotificationItemContainer } from 'src/components/Header/LHSMenu/NotificationsMenu/NotificationsMenu.style';
import { BellIcon } from 'lucide-react';

class NotificationsBetsListState {
    @observable public isOpen: boolean = true;

    public constructor() {
        makeAutoObservable(this);
    }

    @action public toggleOpen = (): void => {
        this.isOpen = !this.isOpen;
    };
}

export const NotificationsMenuBets = observer('NotificationsMenuBets', (): JSX.Element | null => {
    const common = useCommon();
    const stateCentre = NotificationsCentreState.get(common);
    const [state] = React.useState(() => new NotificationsBetsListState());

    const notifications = stateCentre.betReferralNotifications;
    const pendingBetReferralItems: Array<JSX.Element> = [];
    const ongoingBetReferralItems: Array<JSX.Element> = [];
    const currentStaffAccountId = $appState.sdkStaff.getStaffId();

    for (const notification of notifications) {
        const id = notification.id;

        const item = (
            <NotificationsMenuBetsItem
                betReferralNotification={notification}
                currentStaffAccountId={currentStaffAccountId}
                onAssignTrader={stateCentre.onAssignTraderHandle}
            />
        );

        if (notification.status === 'pending') {
            pendingBetReferralItems.push(
                <NotificationsMenuBetsItemContainer
                    key={id}
                    data-test='notifications-list-item'
                >
                    {item}
                </NotificationsMenuBetsItemContainer>
            );
        } else {
            ongoingBetReferralItems.push(
                <NotificationsMenuBetsItemContainer
                    key={id}
                    data-test='notifications-list-item'
                >
                    {item}
                </NotificationsMenuBetsItemContainer>
            );
        }
    }

    return (
        <NotificationItemContainer>
            <NotificationHeaderWrapper
                name='Notifications'
                icon={<BellIcon className='stroke-1' />}
                onClick={state.toggleOpen}
                isOpen={state.isOpen}
            />

            <NotificationListContainer isOpen={state.isOpen}>
                {pendingBetReferralItems}
                {ongoingBetReferralItems}
            </NotificationListContainer>
        </NotificationItemContainer>
    );
});
